import { Badge as MaterialBadge } from "@material-ui/core";
import React from "react";

type BadgeProps = {
  count: number;
  children: JSX.Element;
};

const Badge = (props: BadgeProps) => {
  return props.count > 0 ? (
    <MaterialBadge
      className="alerts-menu__badge"
      color="secondary"
      badgeContent={props.count}
      variant="dot"
    >
      {props.children}
    </MaterialBadge>
  ) : (
    props.children
  );
};

export default Badge;
